const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  "https://97atr26c9f.us-east-2.awsapprunner.com";

export async function submitMedicareLead(payload) {
  const response = await fetch(`${API_BASE}/api/medicare-lead`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.error || "Lead submission failed");
  }

  return data;
}
